import React from 'react'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { useTranslation } from '@flows-ui/utils/i18n'
import { h3 } from '@ui-kit/core/typography'

const loaderStyles = tv({
  slots: {
    overlay: 'fixed inset-x-0 bottom-0 top-[57px] z-30 flex items-center justify-center bg-white',
    inner: 'max-h-[350px] max-w-[316px]',
    title: h3({ type: 'primary', align: 'center' }),
  },
})

export const Loader = () => {
  const { t } = useTranslation()
  const styles = loaderStyles()

  return (
    <View className={styles.overlay()} testID="quote-loader">
      <View className={styles.inner()}>
        <Text className={styles.title()}>{t('sharedFlows_common:steps.quote.loader.title')}</Text>
      </View>
    </View>
  )
}
